import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronLeft, ChevronRight } from '@outdoor-voices/ui';
import css from './ButtonBlock.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var ButtonBlock = function ButtonBlock(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      height = _ref.height,
      left = _ref.left,
      onClick = _ref.onClick;
  var rootClasses = cc([className, css.root, _defineProperty({}, css.left, left), _defineProperty({}, css.right, !left), _defineProperty({}, css.disabled, disabled)]);
  return /*#__PURE__*/_jsx("div", {
    className: rootClasses,
    style: {
      height: height
    },
    children: /*#__PURE__*/_jsx("button", {
      "aria-label": "Scroll to ".concat(left ? 'previous' : 'next', " item"),
      className: css.button,
      onClick: disabled ? null : onClick,
      disabled: disabled,
      title: left ? 'Previous' : 'Next',
      type: "button",
      children: left ? /*#__PURE__*/_jsx(ChevronLeft, {}) : /*#__PURE__*/_jsx(ChevronRight, {})
    })
  });
};

ButtonBlock.displayName = 'ButtonBlock';
ButtonBlock.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  height: PropTypes.string,
  left: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
ButtonBlock.defaultProps = {
  className: '',
  height: '100%'
};
export default ButtonBlock;